/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const facilityInfrastructureEnumsCurrentStatusOptionEnum = {
    Online: 'Online',
    Offline: 'Offline',
    Busy: 'Busy',
    Overwhelmed: 'Overwhelmed',
    Saturated: 'Saturated',
    Other: 'Other',
} as const;

export type FacilityInfrastructureEnumsCurrentStatusOptionEnumKey =
    (typeof facilityInfrastructureEnumsCurrentStatusOptionEnum)[keyof typeof facilityInfrastructureEnumsCurrentStatusOptionEnum];

export type FacilityInfrastructureEnumsCurrentStatusOption = FacilityInfrastructureEnumsCurrentStatusOptionEnumKey;
